import { signUp } from '../../../modules/auth/auth.repository';
import { AccountResponse, SignUpPayload } from '../../../modules/auth/types';

export const signUpUseCase = async (payload: SignUpPayload): Promise<AccountResponse> => {
  return signUp(payload);
};
